import { Link } from "react-router-dom";
import { Phone, Mail, Building2, TrendingUp, Users, ShieldCheck } from "lucide-react";

const buildWa = () => {
  const text = encodeURIComponent("Hi Holiday Ice Creams 🍦 — I'd like to know more about franchise / partnership opportunities. Please share details.");
  return `https://wa.me/919235372759?text=${text}`;
};

export default function GrowWithUs() {
  return (
    <section className="py-12 md:py-16" data-testid="grow-with-us-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs tracking-[0.2em] uppercase text-holiday-red font-bold">Grow With Us</p>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.95] mt-3">Open a Holiday<br/><span className="text-holiday-red italic font-serif">in your city.</span></h1>
        <p className="mt-6 max-w-2xl text-base md:text-lg text-choc/85 leading-relaxed">26 years. 4.9★ rating. A loyal customer base. We're now opening franchise & distribution partnerships across Eastern UP — Gorakhpur, Deoria, Basti, Maharajganj, Kushinagar.</p>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {[
            { icon: Building2, title: "Parlour franchise", body: "Turn-key counter & seating parlour. Brand assets, menu, training, supply — done." },
            { icon: TrendingUp, title: "Distributor / dealer", body: "City-level cold-chain distributor. Bulk margins, dedicated route." },
            { icon: Users, title: "Catering partner", body: "Run weddings, school tie-ups & corporate events with our supply." },
          ].map((c, i) => (
            <article key={i} className="bg-white rounded-[2rem] p-7 cushion border border-[#F0E4E4]" data-testid={`grow-card-${i}`}>
              <div className="w-12 h-12 rounded-full bg-mint flex items-center justify-center mb-4">
                <c.icon className="w-5 h-5 text-holiday-red"/>
              </div>
              <h3 className="font-display text-2xl">{c.title}</h3>
              <p className="text-sm text-choc/80 mt-2 leading-relaxed">{c.body}</p>
            </article>
          ))}
        </div>

        <div className="mt-16 bg-mint rounded-[2.5rem] p-8 md:p-14 cushion border border-[#F0E4E4]" data-testid="grow-why-block">
          <h2 className="font-display text-3xl md:text-5xl">Why partner with Holiday?</h2>
          <ul className="mt-8 grid md:grid-cols-2 gap-6 text-base">
            {[
              ["★ 4.9 rating brand", "31 verified Google reviews. Already-loved across Gorakhpur."],
              ["★ Bulk-ready supply", "We've delivered 10L+ tubs for weddings, schools, corporates."],
              ["★ Three-gen recipe", "26 years of refinement. Recipe IP stays with the partner agreement."],
              ["★ Hands-on training", "We send a chef + trainer to your city for the first 30 days."],
              ["★ Cold-chain support", "−18°C boxes & branded freezers shipped on franchise approval."],
              ["★ Marketing kit", "Social media templates, Google Business, JustDial onboarding included."],
            ].map(([h, d], i) => (
              <li key={i} className="flex items-start gap-3"><ShieldCheck className="w-5 h-5 text-holiday-red mt-0.5 shrink-0"/><div><span className="font-bold">{h}.</span> <span className="text-choc/80">{d}</span></div></li>
            ))}
          </ul>
        </div>

        <div className="mt-16 bg-holiday-red text-white rounded-[2.5rem] p-10 md:p-14 cushion text-center" data-testid="grow-cta">
          <h2 className="font-display text-3xl md:text-5xl">Ready? Tell us about your city.</h2>
          <p className="mt-4 max-w-xl mx-auto opacity-90">Drop your details, our team calls back within 24 hours with a partnership pack.</p>
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <a href={buildWa()} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-white text-holiday-red px-7 py-3.5 rounded-full font-bold">Start the chat →</a>
            <a href="tel:9235372759" className="inline-flex items-center gap-2 bg-choc text-cream px-7 py-3.5 rounded-full font-bold"><Phone className="w-4 h-4"/> 9235372759</a>
            <Link to="/contact" className="inline-flex items-center gap-2 bg-cream/20 border border-white/40 px-7 py-3.5 rounded-full font-bold"><Mail className="w-4 h-4"/> Email enquiry</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

